import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';

export const orderDeliveryService = {
  getOrderDeliveryList,
  searchOrderDelivery,
  filterOrderDelivery,
  getOrderDeliveryDetails,
};

async function getOrderDeliveryList() {
  return apiClient.get(`/order-delivery`, authHeader());
}

async function searchOrderDelivery(text) {
  return apiClient.get(`/order-delivery/search?search=${encodeURIComponent(text)}`, authHeader());
}

async function filterOrderDelivery(body) {
  return apiClient.post(`/order-delivery/filter`, body, authHeader());
}

async function getOrderDeliveryDetails(id) {
  return apiClient.get(`/order-delivery/details/${id}`, authHeader());
}
